import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {AuthGuardService} from './@core/mock/auth-guard.service';
import {AuthGuardAuthsService} from './@core/mock/auth-guard-auths.service';
import {NotFoundComponent} from "./pages/miscellaneous/not-found/not-found.component";

export const routes: Routes = [
  {
    canActivate: [AuthGuardService],
    path: 'pages',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
    data: {
      breadcrumb: 'Trang chủ'
    },
  },
  {
    canActivate: [AuthGuardAuthsService],
    path: 'auths',
    loadChildren: () => import('./auths/auths.module')
      .then(m => m.AuthsModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
  {
    path: '404',
    component: NotFoundComponent,
  },
];

const config: ExtraOptions = {
  useHash: false
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
